import React from 'react';
import { IconButton, Typography } from 'seagull';
import { WideArrowBackward } from 'seagull/icons';
import styles from "./MobilePane.module.scss";
import { relationshipModel } from "../../../../models";
export function MobilePane(_ref) {
  let {
    vendorDetails,
    hideBack,
    activeStepIndex,
    onBackClick,
    'data-testid': testid
  } = _ref;
  const vendorLogoUrl = relationshipModel.vendorLogoUrl({
    vendor: vendorDetails
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    "data-testid": testid && "".concat(testid, "-mobile")
  }, /*#__PURE__*/React.createElement("div", null, activeStepIndex > 0 && !hideBack && onBackClick ? /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => onBackClick(activeStepIndex - 1),
    "data-testid": testid && "".concat(testid, "-mobile-back-btn")
  }, /*#__PURE__*/React.createElement(WideArrowBackward, null)) : null), vendorLogoUrl ? /*#__PURE__*/React.createElement("img", {
    className: styles.logoImg,
    src: vendorLogoUrl
  }) : /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    weight: "normal"
  }, relationshipModel.vendorName({
    vendor: vendorDetails
  })), /*#__PURE__*/React.createElement("div", null));
}